// Indices de l'enum SsoSignUpResultError renvoyée par l'API : toute insertion côté back décale ces valeurs.
export enum SsoError {
  TokenNotValid = 0,
  EmailIsNull = 1,
  NoAccount = 2,
  AccountIsPending = 3,
  AmbiguousAccount = 4,
  NoUsableRight = 5,
  AccountIsLocked = 6,
  TokenExpired = 7,
  TokenAlreadyUsed = 8
}
